/**
 * Format a number with thousands separators (e.g. 3000 → "3,000")
 */
export function formatNumber(value: number | null | undefined): string {
    if (value === null || value === undefined) return ''
    return value.toLocaleString('en-US')
}

/**
 * Format a currency amount, rounding to integer (e.g. 1234567 → "1.234.567")
 * Uses vi-VN locale (dot as thousands separator)
 */
export function formatCurrency(value: number | null | undefined): string {
    if (value === null || value === undefined) return ''
    return new Intl.NumberFormat('vi-VN', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(Math.round(value))
}
